
import React, { useEffect, useState, useMemo } from "react";
import PrimarySearchAppBar from "./NavBar/NavBar";
import useStyles from "../styles/navbar/TableHeadStyles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TableFilterFields from "./Table/TableFilterFields";
import TableData from "./Table/Table";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Tab, Tabs } from "@mui/material";
import { KeyboardReturn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import LastChangesModal from "./Modals/lastChangesModal";
import { MaterialsPanel } from "./Materials/MaterialsPanel";

const ORDERS_TAB = 0;
const MATERIALS_TAB = 1;

export const MainLayout = ({ accounts, isAuthenticated, accessToken }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(ORDERS_TAB);
  const [orders, setOrders] = useState({});
  const [ordersHistoryDate, setOrdersHistoryDate] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ product: "", dateFrom: null, dateTo: null, be: "" , recipient: ""});
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [loadingFilteredData, setLoadingFilteredData] = useState(false);
  const [open, setOpen] = useState(false);
  const [last10Orders, setLast10Orders] = useState([]);
  const handleClose = () => {
    setError(null);
    window.location.reload();

  };
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const fetchDataFromAPI = async () => {
    setError(null);
    try {
      //https://node.zeitrec.com/api/orders
      //http://localhost:5002/api/orders"
      const ordersRes = await fetch("https://node.zeitrec.com/api/orders", {
        method: "GET",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (!ordersRes.ok) {
        setError(false);
        throw new Error("Błąd przy ładowaniu danych");
      }
      const data = await ordersRes.json();    
      setOrders(data);
      //http://localhost:5002/api/orders/date-history
      //https://node.zeitrec.com/api/orders/date-history
      const ordersHistoryDateRes = await fetch("https://node.zeitrec.com/api/orders/date-history", {
        method: "GET",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if(!ordersHistoryDateRes.ok){
        console.log(ordersHistoryDateRes.error)
        setError(false);
        throw new Error("Błąd przy ładowaniu danych");
      }
      const dataOrdersHistory = await ordersHistoryDateRes.json();
      setOrdersHistoryDate(dataOrdersHistory)
      setLoading(false);
      setError(null);
    } catch (error) {
      setError(error.message);
    }
  };

  const parseDate = (dateStr) => {
    const [day, month, yearAndTime] = dateStr.split("-");
    const [year, time] = yearAndTime.split(" ");
    return new Date(`${year}-${month}-${day}T${time || "00:00"}`);
};

  useEffect(() => {
    if (ordersHistoryDate != null) {
        const getLast10ChangesMap = (ordersHistoryDate) => {
            const lastChanges = new Map();

            Object.entries(ordersHistoryDate).forEach(([orderId, orderData]) => {
                Object.entries(orderData).forEach(([numerWiersz, zmiany]) => { 


                  const allDates = zmiany
                  .map(entry => entry.split(";"))
                  .sort((a, b) => parseDate(b[1].substring(0,10)) - parseDate(a[1].substring(0,10)));

                    if (allDates.length > 0 && orders?.[orderId]?.[numerWiersz] !== undefined) {
                        lastChanges.set(orderId, allDates[0]+ "," + numerWiersz); 
                    }
                });
            });


            return new Map([...lastChanges.entries()]
            .sort((a, b) => {
                const dateA = parseDate(a[1].split(",")[1].substring(0,10));
                const dateB = parseDate( b[1].split(",")[1].substring(0,10));
                return dateB - dateA;
            }).slice(0,10));

            // return new Map([...lastChanges.entries()]
            //     .sort((a, b) => b[1].split(",")[1].localeCompare(a[1].split(",")[1])))
            //     // .slice(0, 10));
        };

        setLast10Orders(getLast10ChangesMap(ordersHistoryDate));
    }
}, [ordersHistoryDate]);

  useEffect(() => {
    setLoadingFilteredData(true);
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
      setLoadingFilteredData(false);
    }, 600);
    return () => clearTimeout(timer);
  }, [filters]);

  useEffect(() => {
    if (accessToken) {
      fetchDataFromAPI();

      const intervalId = setInterval(() => {
        fetchDataFromAPI();
      }, 30 * 60 * 1000 );
      return () => clearInterval(intervalId);
    }
  }, [accessToken]);
  const rows = useMemo(
    () =>
      Object.entries(orders).flatMap(([orderId, order]) =>
        Object.entries(order)
          .filter(([key]) => !isNaN(key))
          .map(([key, details]) => ({
            orderId,
            orderNumber: key,
            recipient: order.goodsRecipient,
            product: details.custProductNoItem,
            be: details.be,
            dateFrom: details.deadlineWeekOrDay,
            ytransname: details.ytransname,
            qty: details.outstDelQty
          }))
      ),
    [orders]
  );
  const filteredRows = useMemo(() => {
    return rows.filter((row) => {
      const filtersProduct = debouncedFilters.product.toLowerCase() || "";
      const filtersRecipient = debouncedFilters.recipient.toLowerCase() || "";
      const rowProduct = row?.product?.toLowerCase() || "";
      const rowRecipient = row?.recipient?.toLowerCase() || "";
      const rowBe = row.be?.toLowerCase() || "";
      const rowDateFrom = row.dateFrom || "";
      const filtersBe = debouncedFilters.be.toLowerCase() || "";
      const dateFromCondition =
        debouncedFilters.dateFrom === null ||
        new Date(rowDateFrom.slice(0, 4), rowDateFrom.slice(4, 6) - 1, rowDateFrom.slice(6, 8)) >=
          new Date(debouncedFilters.dateFrom);
      const dateToCondition =
        debouncedFilters.dateTo === null ||
        new Date(rowDateFrom.slice(0, 4), rowDateFrom.slice(4, 6) - 1, rowDateFrom.slice(6, 8)) <=
          new Date(debouncedFilters.dateTo);
      return (
        rowProduct.includes(filtersProduct) &&
        rowRecipient.includes(filtersRecipient) &&
        rowBe.includes(filtersBe) &&
        dateFromCondition &&
        dateToCondition
      );
    });
  }, [rows, debouncedFilters]);
  const products = useMemo(() => Array.from(new Set(filteredRows.map((row) => row.product))), [filteredRows]);
  const recipient = useMemo(() => Array.from(new Set(filteredRows.map((row) => row.recipient))), [filteredRows]);
  const renderOrdersTab = () => {
    if (loading && error == null) {
      return (
        <div style={{textAlign: "center", marginTop: "20%"}}>
            <CircularProgress color="error"/>
            <div>Ładowanie danych...</div>
        </div>
      );
    }
    if (loading && error) {
      return (
        <Dialog
        open={Boolean(error)}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Data Loading Error"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          Error loading data. Please try again. If the problem persists, contact your administrator.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
      );
    }
    return (
      <div>
        <TableFilterFields
          filters={filters}
          products={products}
          recipient={recipient}
          setFilters={setFilters}
          AdapterDateFns={AdapterDateFns}
        />
        <TableData filteredRows={filteredRows} loadingFilteredData={loadingFilteredData} ordersHistoryDate={ordersHistoryDate}/>
      </div>
    );
  };

  return (

   <>
        <PrimarySearchAppBar
        isAuthenticated={true}
          accountName={accounts[0]?.name || ""}
          setOpen={setOpen}
        />
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTab}
            onChange={(event, value) => setActiveTab(value)}
          >
            <Tab label={t("ordersTab")} />
            <Tab label={t("materialsTab")} />
          </Tabs>
        </Box>

        {activeTab === ORDERS_TAB && renderOrdersTab()}
        {activeTab === MATERIALS_TAB && (
          <MaterialsPanel accessToken={accessToken} />
        )}

        <LastChangesModal open={open} setOpen={setOpen} last10Orders={last10Orders} orders={orders}/>
     </>





  );
};
